import React, { useState } from 'react';
import { getLoggedInUser } from "../../../../helpers/authUtils";
import IconLink from '../../../../assets/svg/ic-actions-new-window.svg';
import IconImpressora from '../../../../assets/svg/print.svg';
import { openReceituario } from '../../../../Libs/Docs.js';
import ModalEnvio from '../../../../gb-components/ModalEnvio';

const CardReceituario = ({ interacao, paciente, profissional, DataCriacao, prescricao, receituarioId, OpenModal, Hora }) => {

    const [profNome, setProfNome] = useState('');
    const [isVisibleSend, setIsVisibleSend] = useState(false);
    const sending = false;

    const renderBody = () => {
        return (
            <div style={{ whiteSpace: "pre-line" }}>
                {prescricao ? (
                    <div dangerouslySetInnerHTML={{ __html: prescricao }}></div>
                ) : null}
            </div>
        )
    }

    return (
        <>
            <div className={"gb-card mb-3"}>
                <div className={getLoggedInUser().username === profissional ? "gb-card-header profissional" : "gb-card-header"}>
                    <p>{profissional ? profissional : profNome}{" "}{/* {Concluida ? (<p>{Concluida}</p>) : null} */}</p>
                    <div style={{ textAlign: getLoggedInUser().username === profissional ? 'right' : null, }}>
                        {DataCriacao ? (
                            <span className="gb-card-header-hora">
                                {" "}{DataCriacao.replace("-", "/").replace("-", "/")}{" "}{Hora ? Hora : ""}
                            </span>
                        ) : null}
                        <div style={{ textAlign: getLoggedInUser().username === profissional ? 'left' : 'right' }}>

                            <a href="#" onClick={() => {
                                openReceituario(paciente.id, receituarioId);
                            }}>
                                <img src={IconImpressora} style={{ marginLeft: 15 }} />
                            </a>

                            {/* {sending ? (<PreLoaderWidget ></PreLoaderWidget>) : ()} */}
                            <a href="#" onClick={() => setIsVisibleSend(true)}>
                                <img src={IconLink} style={{ marginLeft: 15 }} />
                            </a>
                        </div>
                    </div>

                </div>

                <div className="gb-card-body">
                    {renderBody()}
                </div>

            </div>

            {(receituarioId) ? <ModalEnvio visible={isVisibleSend}
                close={() => setIsVisibleSend(false)}
                pacienteId={paciente.id}
                card={'receituario'}
                docId={receituarioId}
                email={paciente.paciente.email}
                telefone={paciente.paciente.whatsapp ? paciente.paciente.whatsapp : paciente.paciente.telefones}
                visualizar={false} /> : null}
        </>

    )
}

export default CardReceituario;